<template lang="pug">
  y-dialog(fill-height fluid v-model="showModal" transition="fade-transition" max-width="600px")
    v-card(align="center")
      div.pt-3.px-3
        p.mb-1 {{ text }}
        v-color-picker(show-swatches mode="hexa" v-model="pickColor")
      v-card-actions
        v-spacer
        v-btn(color='grey', text @click='showModal = false')
          | {{ $t('cancel') }}
        v-btn.mr-2(color='primary' depressed height=32 @click="pick")
          div {{ $t('pick') }}
</template>

<script>
export default {
  name: 'ColorPicker',
  props: ['open', 'color', 'text'],
  data: () => ({
    pickColor: '#FFFFFF'
  }),
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
  },
  mounted () {
    this.pickColor = this.color
  },
  methods: {
    pick () {
      this.$emit('update:color', this.pickColor)
      this.showModal = false
    }
  }
}
</script>